import { render, staticRenderFns } from "./contract-group-edit-modal.component.vue?vue&type=template&id=2e8b523e&scoped=true&"
import script from "./contract-group-edit-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-group-edit-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-group-edit-modal.component.vue?vue&type=style&index=0&id=2e8b523e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b523e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
